<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>                                                 
                    <h1>
                        Manage Events
                    </h1>
                    
                    <b-button variant="outline-primary mt-1" to="/admin/events/create">
                        Create New Event
                    </b-button>

                    <b-row>
                        <b-input-group class="col-md-6 mt-5">
                            <b-form-input v-model="filter" placeholder="Type to search" class="mb-0" />

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-row>
                    
                    <b-table class="mt-3" 
                        striped
                        hover
                        stacked="md"
                        :filter="filter"
                        :items="events"
                        :fields="fields">

                        <template slot="actions" slot-scope="row">
                            <b-button class="btn-info mr-2" :to="{ name: 'edit-event', params: { id: row.item.id } }">
                                Edit
                            </b-button>

                            <b-button class="btn-danger" @click="askDeleteItem(row.item)">
                                Delete
                            </b-button>
                        </template>
                    </b-table>

                    <b-modal 
                        v-model="show_delete_modal"
                        id="delete-modal"
                        title="Warning"
                        @ok="deleteItem()"
                        header-bg-variant="danger"
                        header-text-variant="light"
                        ok-title="Delete"
                        ok-variant="danger">
                        Are you sure you want to permanently delete this event?
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import eventRepository from "@/repository/events"

    export default {
        data() {
            return {
                fields: [
                    {
                        label: "Client",
                        key: 'client_name',
                        sortable: true
                    },
                    {
                        key: 'name',
                        sortable: true
                    },
                    'actions'
                ],
                show_delete_modal: false,
                event_to_delete: null,
                filter: "",
                loaded:false,
                events:[],
            }
        },

        methods: {
            askDeleteItem(item) {
                this.show_delete_modal = true;
                this.event_to_delete = item;
            },
            
            deleteItem() {
                eventRepository.destroy(this.event_to_delete.id)
                    .then(response => {
                        let id = this.events.findIndex(event => event.id == this.event_to_delete.id);
                        this.events.splice(id, 1);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Event Deleted',
                            text: 'Event successfully deleted.'
                        });
                    })
            }
        },

        mounted() {
            eventRepository.getAll({
                include: 'client'
            }).then(res => {
                res.data.forEach(e => {
                    if (e.client !== null) e.client_name = e.client.name;
                    this.events.push(e);
                });
                this.loaded = true;
            });
        }
    }
</script>

<style scoped>

</style>